import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as CommonFunction from '../../services/common.function';
import { RequestBodyAddEditClient } from '../../models/client/request-body-add-edit-client.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  constructor(private http: HttpClient) {
   }

   getClients(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/Client/GetClients`, body).pipe(map((response: any) => {
      return response
    }));
  }

  clientArchived(Id: string): Observable<any> {
    const body: any = {
      uiClientId: Id,
      stTimeZone: CommonFunction.GetTimeZone()
    }
    return this.http.post(`${environment.WebApiURL}api/Client/Archive`, body).pipe(map((response: any) => {
      return response
    }));
  }
  GetImageUrl(stLogoUrl: string): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/Client/GetImageUrl?stLogoUrl=' + stLogoUrl).pipe(map((response: any) => {
      return response
    }));
  }
  viewClient(data: any): Observable<any> {
    const body: any = {
      TimeZone: CommonFunction.GetTimeZone(),
      clientId: data.clientId,
      stSearchText: data.stSearchText,
      stSortColumn: data.stSortColumn,
      stSortOrder: data.stSortOrder,
      inOffset: data.inOffset,
      inLimit: data.inLimit,
    }
    return this.http.post(`${environment.WebApiURL}api/Client/GetClients`, body).pipe(map((response: any) => {
      return response
    }));
  }

  addEditClient(data: any, clienId: any, logo: File | null): Observable<any> {
    let cId;
    if (clienId == 'null' || clienId == null) {
      cId = '';
    }
    else {
      cId = clienId;
    }
    const formData = new FormData();
    console.log("data");
    console.log(data);

    formData.append("uiClientId", cId);
    formData.append("stClient", data.clientName);
    formData.append("stEmail", data.email);
    formData.append("stContactName", data.contactName);
    formData.append("stContactNumber", data.contactNo);
    formData.append("dtExpiryDate", data.clientExpiryDate);
    formData.append("flgIsActive", data.status);
    formData.append("stColorCode", data.colorCode);
    formData.append("UserCreationType", data.UserCreationType == null || undefined ? false : data.UserCreationType);
    formData.append("flgIsAllowDuplicate", "false");
    formData.append("stMonitoringFrequency", data.monitoringFrequency);
    formData.append("stUtilizationReportFrequency", data.utilizationReportFrequency);
    formData.append("stIntuitCustomerId", data.intuitCustomerId == null || undefined ? '' : data.intuitCustomerId);
    formData.append("inTier", data.inTier);
    formData.append("inProfilePaymentId", data.inProfilePaymentId);
    formData.append("stAddress", data.stAddress);
    formData.append("isReviewRequired", data.isReviewRequired);
    formData.append("isRequiredInvoice", data.isRequiredInvoice);
    formData.append("flgIsAllowLowConfidenceScore", data.flgIsAllowLowConfidenceScore);
    formData.append("flgIsAllowAdditionalIdentity", data.flgIsAllowAdditionalIdentity);
    formData.append("flgIsIncludeAuth", data.flgIsIncludeAuth);
    formData.append("flgIsInsuranceType", data.flgIsInsuranceType);
    formData.append("stFaxNumber", data.stFaxNumber);
    formData.append("flgIsPermitVM", data.flgIsPermitVM);
    formData.append("stLogo", data.stLogo);
    formData.append("flgIsClientLogo", data.flgIsClientLogo);
    formData.append("inReportType", data.inReportType);
    formData.append("inPriority", data.inPriority);
    formData.append("inTurnaroundTime", data.inTurnaroundTime);
    formData.append("inDeliverable", data.inDeliverable);
    formData.append("flgIsVisibleWebPage", data.isVisibleWebPage);
    formData.append("flgIsWhiteLabel", data.flgIsWhiteLabel);
    formData.append("stReportTypes", data.stReportTypes)
    formData.append("flgIsAllowAdditionalScreenshot", data.flgIsAllowAdditionalScreenshot);
    formData.append("flgIsEmailOnPublish", data.flgIsEmailOnPublish);
    if (logo instanceof File) {
      formData.append("logo", logo);
    }

    return this.http.post(`${environment.WebApiURL}api/Client/Create`, formData).pipe(map((response: any) => {
      return response
    }));
  }

   getClientById(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/Client/GetClients`, body).pipe(map((response: any) => {
      return response
    }));
  }

  getPaymentProfileIdNamePairs(): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/Client/getPaymentProfileIdNamePairs');
   }

   getActiveClients(stTimeZone: string): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/Client/getActiveClients?stTimeZone=' + stTimeZone).pipe(map((response: any) => {
      return response.data
    }));
  }

}